import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-data",
	templateUrl: "./manage-data.component.html",
	styleUrls: ["./manage-data.component.scss"]
})
export class ManageDataComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	public hiStatus: string;
	public hiProgress: number;

	public statesStatus: string;
	public statesProgress: number;

	public assetOps: APIResults.Operation[] = null;
	public selectedOperation: APIResults.Operation = null;
	public opDatafiles: APIResults.DataFile[];

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		this.hiProgress = undefined;
		this.hiStatus = undefined;

		this.statesProgress = undefined;
		this.statesStatus = undefined;

		await this.RefreshAssetOps();
	}

	private async RefreshAssetOps() {
		this.assetOps = [];
		this.assetOps = await this.api.GetOperations(this.asset.asset_id, 800, true);
	}

	public async GetDatafiles() {
		this.opDatafiles = undefined;
		this.opDatafiles = await this.api.GetOperationDatafiles(this.asset.asset_id, this.selectedOperation.operation_id);
	}

	public async GenerateHIs() {
		const result = await this.api.GenerateHIs(this.asset.asset_id);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.hiStatus = status;
			this.hiProgress = progress;
		});
	}

	public async RecalculateStates() {
		const result = await this.api.RecalculateAssetStates(this.asset.asset_id);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.statesStatus = status;
			this.statesProgress = progress;
		});
	}
}
